import { SwapRouteInfoApi, SwapRouteStepInfoApi, SwapRoutesResponseApi } from "../api/swap-routes";
import { SwapRouteInfo, SwapRouteStepInfo, SwapRoutesResponse } from "../domain/swap-routes";

export function parseSwapRoutesResponseFromApi(api: SwapRoutesResponseApi): SwapRoutesResponse {
    return { routes: api.routes.map(parseSwapRouteInfoFromApi) };
}

function parseSwapRouteInfoFromApi(api: SwapRouteInfoApi): SwapRouteInfo {
    return { ...api, steps: api.steps.map(parseSwapRouteStepInfoFromApi) };
}

function parseSwapRouteStepInfoFromApi(api: SwapRouteStepInfoApi): SwapRouteStepInfo {
    return {
        ...api,
        // Trunc guards BigInt() throwing on a malformed fractional config value (fail-open direction).
        minInputAmount: api.minInputAmount !== undefined ? BigInt(Math.trunc(api.minInputAmount)) : undefined
    };
}
